module.exports = __webpack_public_path__ + "fd21e72609731bf07ed4206668798bac.svg";